//key
export const KEY =
  "CF4AEBA04649C8FB207714DB5894489EAD956772B97A236C6D6B0F449FD15B73";

//token
export const TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtc2lzZG4iOiIyMzMyNDQ1NTI4MjEsIDIzMzU0MzY2NDA1NyIsImlhdCI6MTY0MjI3OTE1NCwiZXhwIjoxNjQ0ODcxMTU0fQ.xvGQukv17Xy4kxN6UMRVwKp7-QU-somEJeZdGnZCTO0";

//local url
export const url = "http://localhost:3000";

//dev url
// export const url = "https://pulsedev.mtn.com.gh"

//prod url
//export const url = "https://pulseapp.mtn.com.gh"
